import axios from "axios";
import parser from "xml-js";

const postCadastrarPesquisa = async (cadastros) => {
  try {
    window.Offline.check();
  } catch (e) {
    console.log(e);
  }
  if (window.Offline.state !== "up") {
    let save = localStorage.getItem("savePesquisa");
    if (save === null) {
      localStorage.setItem("savePesquisa", JSON.stringify(cadastros));
    } else {
      save = JSON.parse(save);
      save = save.concat(cadastros);
      localStorage.setItem("savePesquisa", JSON.stringify(save));
    }
    return "Salvo com sucesso";
  }

  let response = await axios.post(
    window.url_api + "/app/zws_app_cadastrar_pesquisa",
    cadastros
  );
  try {
    if (response.data.success) {
      return response.data;
    }
  } catch (e) {
    return [];
  }

  return [];
};

export default {
  postCadastrarPesquisa,
};
